import { Tag, Text } from "@chakra-ui/react";

interface Props {
  label?: string;
  placement?: "top-right" | "top-left";
}

const DiscontinuedBadge = ({
  label = "Discontinued",
  placement = "top-right",
}: Props) => (
  <Tag
    pos="absolute"
    top={3}
    {...(placement === "top-left" ? { left: 3 } : { right: 3 })}
    zIndex={2}
    bg="#142528"
    color="white"
    minH="auto"
    py="3px"
    px="8px"
    borderRadius="full"
    boxShadow="0 2px 8px rgba(20, 37, 40, 0.16)"
  >
    <Text
      fontSize="9px"
      fontWeight={700}
      letterSpacing="0.6px"
      lineHeight="1"
      textTransform="uppercase"
    >
      {label}
    </Text>
  </Tag>
);

export default DiscontinuedBadge;
